import cn from 'classnames';
import { Tile } from '@creditflowresearch/uilib/Tile';
import CorporateMarketDealHeader from '@/creditflowresearch/ui/components/deals/DealListTable/components/DealHeader/CorporateMarketDealHeader';
import EmMarketDealsTable from '@/creditflowresearch/ui/components/deals/DealListTable/DealsTable/EmMarketDealsTable';
import { IssueTileProps } from '@/creditflowresearch/ui/components/deals/DealTiles/IssueTile/IssueTile';

import styles from '@/creditflowresearch/ui/components/deals/DealTiles/IssueTile/issueTile.module.scss';

export const EmMarketIssueTile = ({
  defaultExpandedRowIndexes,
  showDealDetailsByDefault,
  containerClassName,
}: IssueTileProps) => (
  <Tile dataTest="dealTile" className={ cn(styles.container, containerClassName) }>
    <CorporateMarketDealHeader>
      <EmMarketDealsTable
        showDealDetailsByDefault={ showDealDetailsByDefault }
        defaultExpandedRowIndexes={ defaultExpandedRowIndexes }
      />
    </CorporateMarketDealHeader>
  </Tile>
);

export default EmMarketIssueTile;
